<h2 mat-dialog-title>⚠️ Suppression impossible</h2>
<mat-dialog-content>
  <p><b>{{data.message}}</b> est renseigné dans une application.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Retour</button>
</mat-dialog-actions>